import { FormattedMessage, FormattedNumber } from 'react-intl'

import { LinearProgress } from '@gto/ui/linear-progress'
import { Typography } from '@gto/ui/typography'

import { FlipOutProgressSkeleton } from './flip-out-progress-skeleton'

export type FlipOutProgressProps = {
  completed?: boolean
  total: number
  current: number
  loading?: boolean
}

export const FlipOutProgress = ({
  completed = false,
  total,
  current,
  loading = true,
}: FlipOutProgressProps) => {
  if (loading) {
    return <FlipOutProgressSkeleton />
  }

  if (!total) {
    return null
  }

  return (
    <div className="flex flex-col gap-2">
      <Typography
        color="text.secondary"
        variant="subtitle2"
      >
        <FormattedMessage id="promo.allInFlipOuts.yourProgress" />
      </Typography>
      <LinearProgress
        color="primary"
        size="lg"
        value={(current / total) * 100 > 100 ? 100 : (current / total) * 100}
      />
      <div className="flex items-center justify-between gap-4">
        <Typography
          color="text.secondary"
          variant="subtitle3"
        >
          {completed ? (
            <FormattedMessage id="promo.allInFlipOuts.progress.completed.tip" />
          ) : (
            <span>
              <FormattedNumber
                currency="USD"
                style="currency"
                value={current}
              />
              /
              <FormattedNumber
                currency="USD"
                style="currency"
                value={total}
              />
            </span>
          )}
        </Typography>
        <Typography
          color="text.secondary"
          variant="subtitle3"
        >
          {completed ? (
            <FormattedMessage id="promo.allInFlipOuts.progress.completed" />
          ) : (
            <FormattedMessage
              id="promo.allInFlipOuts.progress.diffRequired"
              values={{
                diff: (
                  <FormattedNumber
                    currency="USD"
                    style="currency"
                    value={total - current}
                  />
                ),
              }}
            />
          )}
        </Typography>
      </div>
    </div>
  )
}
